const Query = props => {
  const { warehouseItemsV2 } = props || {};
  const { sqlQuery } = warehouseItemsV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
